// Steps for homepage
const careerSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: "🙋<br>Let' start",
        description: '<b>Here you can find currently available jobs.</b> We have added a few samples that you can review below.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        title: '📎<br>Job templates and job ads',
        description: '<b>In the settings you can create and save templates.</b> When entering a new position, just select a template and all the data will be pre-filled.',
        position: 'right-center',
        showButtons: true,
    },

},
{
    element: ".guide-step-careers-3",
    popover: {
        className: 'image-popover',
        title: '<a href="../careersite" target="_blank" title="More"><img src="/images/guide-careers-1.png"></a>',
        description: 'You can click here later to edit the whole career page of your company',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".guide-step-careers-4",
    popover: {
        title: ' ',
        description: 'Click here to add a new job',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: ' ',
        description: 'Here you can see <b>an overview of all jobs and ads</b> that are posted on your career page.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".action-td",
    popover: {
        title: ' ',
        description: 'If hiring module is active, click here to <b>share</b> the ad on Facebook, Twitter or LinkedIn <b>with only one click</b>. <br><br> By clicking on the icon <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> you can edit your ad',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'View current employees',
        description: 'Discover the onboarding functionality with a timeline <br>(3 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Yes, carry on',
        nextBtnText: 'Understood', // Next button text for this step
        prevBtnText: 'Back',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding#guide");

    }
},
]



export default careerSteps
